import ClipIcon from '@components/icons/Clip.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useModalContext } from '@providers/ModalProvider';
import { usePageContext } from '../../../../../../providers/PageProvider';
import { MenuItemButton } from '../MoreActionsMenu/components/MenuItemButton';

export const AttachBackupButton = () => {
  const { job, manualReload } = usePageContext();

  const { openModal, closeModal } = useModalContext();

  const showBackupFilesModal = () => {
    openModal(ModalNamesEnum.AdminBackupFilesModal, {
      onSuccess: () => {
        closeModal();
        manualReload();
      },
      id: job?.id,
    });
  };

  if (!job || !job.status) {
    return null;
  }

  return (
    <MenuItemButton title="Check Backup Files" onClick={showBackupFilesModal}>
      <ClipIcon />
      Check Backup Files
    </MenuItemButton>
  );
};
